import React from 'react'
import {Context as AppContext} from '../../contexts/App'
import ObjectForm from '../../components/ObjectForm'

import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';

const BundlesCreate = ({open, close, model,  ...rest}) => {
  const app = React.useContext(AppContext)
  const { recall, setRecall } = app
  const { create, update  } = app.bundles

  const scope = model?"Editar" : "Añadir"
  const submit = d=>  model?update(d):create(d)
  return (
    <Dialog onClose={close} open={open}>
      <DialogTitle>{scope} Paquete</DialogTitle>
      <ObjectForm ignored={['id']} recall={recall} submit={submit}
        obj={{name:'', percentage:'', fixed:''}}
        labels={{name:'Nombre', percentage:'Porcentaje', fixed:'Fijo (centavos)'}}
        types={{name:'text', percentage:'number', fixed:'number'}}
        changed={model?{...model}:{}} 
      />
      <Button onClick={() => {setRecall(true);close()}}>{scope}</Button>
    </Dialog>
  )
}
export default BundlesCreate